import React, { useState } from "react";
import useFetchJSONData from "@hooks/useFetchJSONData";

import "./FloatingActionButton.scss";

function FloatingSubActionButton({ text, img, url, alt, isOpenInNewWindow }) {
  const target = isOpenInNewWindow ? "_blank" : "_self";

  return (
    <a className="fab" aria-label={text} href={url} target={target}>
      <img className="fab-image" src={img} alt={alt} />
    </a>
  );
}

function FloatingMainActionButton({
  isOpen,
  toggleMenu,
  mainButtonImg,
  closeButtonImg,
}) {
  return (
    <button onClick={toggleMenu} className="fab" aria-label="Toggle actions">

      {/* Cannot use conditional render because the image render delay */}
      <img src={closeButtonImg} className="fab-image" alt="Close" style={{display: isOpen ? "block" : "none"}}/>
      <img src={mainButtonImg} className="fab-image" alt="3toTalk" style={{display: isOpen ? "none" : "block"}}/>

    </button>
  );
}

export default function FloatingActionButton({isFloatingPromotionViewVisible}) {
  const [isOpen, setIsOpen] = useState(false);

  const { data, loading, error } = useFetchJSONData("floating-action-button");

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  if (
    loading ||
    error ||
    !data ||
    !data.isOn ||
    !data.fabSubActionButtons ||
    data.fabSubActionButtons.length == 0
  )
    return null;

  const { mainButtonImg, closeButtonImg, fabSubActionButtons } = data;

  return (
    <div className={`container-floating-action-button ${isFloatingPromotionViewVisible ? "floating-promotion-view-shown": ""}`}>
      {/* Sub-action buttons */}
      <div className={`container-button-group ${isOpen ? "open" : "closed"}`}>
        {fabSubActionButtons.map(
          ({ text, img, url, alt, isOpenInNewWindow }, i) => (
            <FloatingSubActionButton key={i}
              {...{ text, img, url, alt, isOpenInNewWindow }}
            />
          )
        )}
      </div>

      {/* Main FAB */}
      <FloatingMainActionButton
        {...{ isOpen, toggleMenu, mainButtonImg, closeButtonImg }}
      />
    </div>
  );
}
